<div
  [ngClass]="{
    'py-4':
      fields.fieldType !== 'tableRow' &&
      fields.fieldType !== 'tableHeader' &&
      fields.displayName != '',
  }"
  [formGroup]="formGroup"
>
  <!-- Shared Label -->
  <div
    class="flex flex-row"
    *ngIf="
      fields.fieldType !== 'tableRow' &&
      fields.fieldType !== 'tableHeader' &&
      fields.displayName != ''
    "
  >
    <label
      class="block text-md font-medium text-gray-900 mb-4"
      [ngClass]="{
        required: fields.isRequired && fields.fieldType !== 'checkboxButton',
      }"
    >
      {{ fields.displayName }}
    </label>
  </div>

  <!-- Radio / Single Select -->
  <ng-container
    *ngIf="fields.fieldType === 'radio' || fields.fieldType === 'singleSelect'"
  >
    <div class="flex flex-wrap gap-4">
      <label
        class="inline-flex items-center text-sm text-gray-800"
        *ngFor="let item of fieldsData"
      >
        <input
          class="radio cursor-pointer"
          [name]="fields.fieldName"
          type="radio"
          [value]="item.id"
          [formControl]="control"
          (change)="onRadioChange(item.id)"
        />
        <span class="ml-2 font-medium ms-3">{{ item.text }}</span>
      </label>
    </div>
  </ng-container>

  <!-- Multi Select -->
  <ng-container *ngIf="fields.fieldType === 'multiSelect'">
    <div class="flex flex-wrap gap-4">
      <label
        class="inline-flex items-center text-sm text-gray-800"
        *ngFor="let item of fieldsData"
      >
        <input
          type="checkbox"
          class="checkbox h-5 w-5 text-blue-600 cursor-pointer"
          [value]="item.id"
          (change)="onMultiSelectChange($event, fields)"
          [checked]="formGroup.get(fields.fieldName)?.value?.includes(item.id)"
        />
        <span class="ml-2 font-medium ms-3">{{ item.text }}</span>
      </label>
    </div>
  </ng-container>

  <!-- Checkbox / CheckboxButton -->
  <ng-container
    *ngIf="
      fields.fieldType === 'checkbox' || fields.fieldType === 'checkboxButton'
    "
  >
    <div class="flex flex-wrap gap-4">
      <span
        *ngFor="let item of fieldsData"
        class="inline-flex items-center justify-center px-3 py-1 rounded-md border text-sm font-medium cursor-pointer transition-all w-[160px] text-center hover:bg-secondary-active"
        [ngClass]="{
          'bg-light-warning border-warning text-gray-800 dark:bg-light-warning':
            selectedOptions.includes(
              (item.value ?? item.id ?? item.text)?.toString()
            ),
          'bg-white dark:bg-coal-700 border-gray-300 text-gray-700':
            !selectedOptions.includes(
              (item.value ?? item.id ?? item.text)?.toString()
            ),
        }"
        (click)="selectItem(item)"
      >
        <span class="font-semibold">{{ item.text }}</span>
      </span>
    </div>
  </ng-container>

  <!-- Table Header -->
  <ng-container *ngIf="fields.fieldType === 'tableHeader'">
    <div class="table-container border rounded-md mb-0 bg-gray">
      <div class="table-header">
        <ng-container
          *ngFor="let item of fields.options?.staticOptions; let i = index"
        >
          <div [ngClass]="getColumnClass(item.text, i)">
            {{ item.text }}
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <!-- Single Error Message -->
  <div
    *ngIf="
      formGroup.get(fields.fieldName)?.touched &&
      formGroup.get(fields.fieldName)?.hasError('required')
    "
    class="text-danger text-sm mt-1 px-3"
  >
    This field is required
  </div>
</div>
